
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mls-disclaimers",
      function () {
        return require("private-next-pages/mls-disclaimers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mls-disclaimers"])
      });
    }
  